import React, { useEffect, useRef, useState } from 'react';
import { TextField } from '@mui/material';
import './motion.css';

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const validEmail = (v) => (!v || EMAIL_RE.test(String(v).trim()) ? '' : 'Enter a valid email address');

export default function ValidatedField({ validate, value, onBlur, inputProps, helperText, className = '', ...rest }) {
  const [shown, setShown] = useState(false);
  const [shake, setShake] = useState(false);
  const message = shown ? validate(value) : '';
  const had = useRef('');

  useEffect(() => {
    if (message && !had.current) setShake(true);
    had.current = message;
  }, [message]);

  return (
    <TextField
      {...rest}
      value={value}
      error={!!message || rest.error}
      helperText={message ? <span className="svx-helper">{message}</span> : helperText}
      className={`${shake ? 'svx-shake' : ''} ${className}`}
      onAnimationEnd={() => setShake(false)}
      onBlur={(e) => { if (validate(value)) setShown(true); onBlur?.(e); }}
      inputProps={{
        ...inputProps,
        onInvalid: (e) => {
          if (!validate(value)) return;
          e.preventDefault();
          setShown(true);
          setShake(true);
        }
      }}
    />
  );
}
